angular.module('mercury.directives.feedback', [])
.directive('feedback', ["dialog", "$http", "userinfo", "settings", function(dialog, $http, userinfo, settings) {
  return {
    restrict: 'A',
    link: function postLink(scope, element) {
      element.click(function() {
        scope.feedbackReceived = false;
        scope.feedback = {
          email: userinfo.userDetails().email ? userinfo.userDetails().email : '',
          page: window.location.hash,
          description: '',
          subject: ''
        };

        dialog.open({
          templateUrl: 'directives/feedback/feedback.tpl.html',
          scope: scope
        });
      });

      scope.feedbackSubmit = function(formCtrl) {
        formCtrl.$setSubmitted();
        if (formCtrl.$invalid) {
          return;
        }

        scope.submitting = $http.post(settings.mercHost + '/zendesk', scope.feedback);
        scope.submitting.then(function() {
          scope.feedbackReceived = true;
        });
      };
    }
  };
}]);
